import React from "react";

const CustomSelect = ({
  label,
  name,
  register,
  validation = {},
  options = [],
  error,
  disabled = false,
  placeholder = "Select...",
  valueKey = "value", // Key to use for the option value (e.g., 'id')
  labelKey = "label", // Key to use for the option text (e.g., 'name')
  onChange: customOnChange, // Optional custom handler for side effects
}) => {
  // Extract hook form's onChange to merge with custom logic
  const { onChange, ...rest } = register(name, validation);

  return (
    <div className="w-full flex flex-col gap-2">
      <label className="font-[400] text-xs text-gray-600">
        {label} {validation.required && <span className="text-red-400">*</span>}
      </label>
      <select
        {...rest}
        disabled={disabled}
        onChange={(e) => {
          onChange(e); // Call React Hook Form's internal handler
          if (customOnChange) customOnChange(e); // Call your custom logic (e.g., fetching next dropdown)
        }}
        className={`border rounded-md px-3 py-2 text-sm w-full outline-none transition-colors ${
          disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"
        } ${error ? "border-red-500 focus:border-red-500" : "border-gray-300 focus:border-teal-700"}`}
      >
        <option value="" disabled hidden>
          {placeholder}
        </option>
        {options.map((opt, index) => (
          <option key={index} value={opt[valueKey]}>
            {opt[labelKey]}
          </option>
        ))}
      </select>
      {error && <span className="text-red-500 text-xs">{error.message}</span>}
    </div>
  );
};

export default CustomSelect;